var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"g-header"},[_c('div',{staticClass:"brand"},[_c('router-link',{staticClass:"brand-logo",attrs:{"to":{ path: '/' }}},[_c('img',{attrs:{"src":require("./logo.png"),"alt":"造物商城"}})])],1),_vm._v(" "),_c('button',{staticClass:"nav-toggle c-icon-menu",on:{"click":_vm.btnClick}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-270c1f14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header/header.vue
// module id = null
// module chunks = 